module.exports = {
  version: '0.1.7',
  port: "7000" || 7000,
  host: "0.0.0.0" || '0.0.0.0',
  apiUrl: "https://api.mnj.ru" || 'https://salty-atoll-99108.herokuapp.com',
  staticContentUrl: process.env.STATIC_CONTENT_URL || '',
  defaultLocale: process.env.DEFAULT_LOCALE || 'ru',
  appMode: "production" || 'development',
  appUrl: "https://www.mnj.ru" || 'http://localhost:7000',
  locales: ['en', 'ru'],
  client: {
    clientId: process.env.CLIENT_ID || 'default',
    clientSecret: process.env.CLIENT_SECRET || 'default',
  },
  socialAuthData: {
    fb: {
      appId: 2513011015644066,
    },
    vk: {
      appId: 7123608,
      saveKey: 'L4cvMpHmbzhZuykL6d6R',
      serviceKey: 'd9c41e70d9c41e70d9c41e7083d9a8ace8dd9c4d9c41e7084abd5c13a98eb2f7f22d9d1',
    },
    mailRu: {
      clientId: 'eccb129a0df64c80af98c763bde00adc',
      clientSecret: '11928b68b7ef4bb99d597d48ac993ba7',
    },
    ok: {
      clientId: 512000000562,
    },
  },
  ws: {
    backend: {
      url: "https://api.mnj.ru/" || 'https://salty-atoll-99108.herokuapp.com/',
      protocol: "wss" || 'wss',
    },
    mediaServer: {
      url: "https://medias.mnj.ru/" || 'https://medias.mnj.ru',
      protocol: "wss" || 'wss',
    },
    signalServer: {
      url: "https://signal.mnj.ru/" || 'https://signal.mnj.ru/',
    },
  },
  record: {
    chunkInterval: process.env.RECORD_CHUNK_INTERVAL || 3000,
  },
  cloudPaymentId: "pk_306024e151bb217e0630eafdee1ee" || 'pk_e7e699e85b8c2e8649c8b76a95f53',
  flashPhoner: {
    appKey: "prodMnj" || 'herokuMnj',
  },
  showCallPageDebugPanel: "production" === 'production' ? process.env.DEBUG_FLASHPHONER : false,
  debugVideosession: "production" === 'production' ? process.env.DEBUG_VIDEOSESSION : false,
  debugVideorecord: "production" === 'production' ? process.env.DEBUG_VIDEORECORD : false,
  textEditorApiKey: '0zrfwuhrpjlg47ci3o7k4gujblx15m1ll3yzfre08vfcr7sf',
};
